import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCLibraryGroupReadingSessionsConducted = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Group reading sessions conducted" />
    </Box>
  );
};
